/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Confirmation_Not_DecidableInputs */

const en_error_order_confirmation_not_decidable = /** @type {(inputs: Error_Order_Confirmation_Not_DecidableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This confirmation can't be answered any more: Tomorrow sent a newer one, or the order is closed.`)
};

/**
* | output |
* | --- |
* | "This confirmation can't be answered any more: Tomorrow sent a newer one, or the order is closed." |
*
* @param {Error_Order_Confirmation_Not_DecidableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_order_confirmation_not_decidable = /** @type {((inputs?: Error_Order_Confirmation_Not_DecidableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Confirmation_Not_DecidableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_order_confirmation_not_decidable(inputs)
});